import astonMartin from '../assets/aston-martin-v12-speedster-dbr1.jpg';
import audi from '../assets/audi-r8-v10-decennium-2019.jpg';
import bentley from '../assets/bentley-bentayga-s-black-edition-2024.jpg';
import bmw from '../assets/bmw-m5-f90-cs-2022.jpg';
import bugatti from '../assets/bugatti-chiron-sport-les-legendes-du-ciel-2021.jpg';
import ferrari from '../assets/ferrari-812-competizione-2021.jpg';
import ford from '../assets/ford-mustang-shelby-gt500-2022.jpg';
import lamborghini from '../assets/lamborghini-urus-s-2023.jpg';
import landRover from '../assets/land-rover-defender-110-v8-2022.jpg';
import mclaren from '../assets/mclaren-765lt-spider-2022.jpg';
import mercedes from '../assets/mercedes-amg-gt3-race.jpg';
import porsche from '../assets/porsche-911-992-gt3-rs-2023.jpg';

export const carCollection = [
    {
        make: 'Aston Martin', 
        model: 'V12 Speedster DBR1', 
        engine: '5.2L V12 Twin-Turbo', 
        power: 700, 
        year: 2023, 
        price: 450,
        image: astonMartin
    },
    {
        make: 'Audi', 
        model: 'R8 V10 Decennium', 
        engine: '5.2L V10', 
        power: 620, 
        year: 2023, 
        price: 550,
        image: audi
    },
    {
        make: 'Bentley', 
        model: 'Bentayga S Black-edition', 
        engine: '4.0L V8 Twin-Turbo', 
        power: 542, 
        year: 2023, 
        price: 300,
        image: bentley
    },
    {
        make: 'BMW', 
        model: 'F90 M5 Competition', 
        engine: '4.4L V8 Twin-Turbo', 
        power: 617, 
        year: 2023, 
        price: 450,
        image: bmw
    },
    {
        make: 'Bugatti', 
        model: 'Chiron Sport', 
        engine: '8.0L W16 Quad-Turbo', 
        power: 1479, 
        year: 2023, 
        price: 1500,
        image: bugatti
    },
    {
        make: 'Ferrari', 
        model: '812 Competizione', 
        engine: '6.5L V12', 
        power: 830, 
        year: 2023, 
        price: 900,
        image: ferrari
    },
    {
        make: 'Ford', 
        model: 'Mustang Shelby GT500', 
        engine: '5.2L Supercharged V8', 
        power: 760, 
        year: 2023, 
        price: 300,
        image: ford
    },
    {
        make: 'Lamborghini', 
        model: 'Urus S', 
        engine: '4.0L V8', 
        power: 657, 
        year: 2023, 
        price: 650,
        image: lamborghini
    },
    {
        make: 'Land Rover', 
        model: 'Defender 110 V8', 
        engine: '5.0L Supercharged V8', 
        power: 518, 
        year: 2023, 
        price: 250,
        image: landRover
    },
    {
        make: 'McLaren', 
        model: '765LT Spider', 
        engine: '4.0L Twin-Turbo V8', 
        power: 765, 
        year: 2023, 
        price: 900,
        image: mclaren
    },
    {
        make: 'Mercedes Benz', 
        model: 'AMG GT3-Race', 
        engine: '6.3L V8', 
        power: 580, 
        year: 2023, 
        price: 750,
        image: mercedes
    },
    {
        make: 'Porsche', 
        model: '911 GT3 RS', 
        engine: '4.0L Flat-6', 
        power: 520, 
        year: 2023, 
        price: 800,
        image: porsche
    }
];